import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../components/css/ReusableModal.css";
import { Input, Button, Select, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import clientService from "../../services/clientService";
import AddClientModal from "./AddClientModal";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";
import { DatePicker } from "antd";
import axiosInstance from "../../services/axiosInstance";
import { catchError } from "../../utils/errorHandler";
const { Option } = Select;

const SearchFilters = ({
  onSearch,
  pagination,
  getAllClients,
  filtersList,
  typeChoices,
}) => {
  
  const { isMobile } = useIsMobile();
  const [filters, setFilters] = useState({
    email: "",
    username: "",
    ownership: "",
    inactive_since_last_quarter: "",
    visibility: "",
    start_date: "",
    end_date: "",
    type:"",
    site:"",
    phone_no:"",
    status:""
  });

  const [websites, setWebsites] = useState([]);
  const [owners, setOwners] = useState([]);
  const [remarksStatus, setRemarksStatus] = useState([]);
  const [visibilities, setVisibilities] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  

  useEffect(() => {
    const fetchWebsites = async () => {
      const result = await clientService.getWebsitesList();
      // Check for API call success and ensure result.data.data is an array, otherwise set to []
      if (result && result.success && Array.isArray(result.data?.data)) {
        setWebsites(result.data.data);
      } else {
        setWebsites([]); // Save [] if response is null or not an array
        message.error("Failed to load websites");
      }
    };

    const fetchOwners = async () => {
      const result = await clientService.getOwnersList();
      if (result.success) {
        setVisibilities(result.data.data);
        setOwners(result.data.data);
      } else {
        message.error("Failed to load owners");
      }
    };

    const fetchDirectSignupStatus = async () => {
      try {
        const res = await axiosInstance.get("useraccount/v2/direct-signup-log/status-choices/")
        if (res?.status === 200 && res?.data?.status) {
          setRemarksStatus(res?.data?.data || [])
        }
      } catch (err) {
        await catchError(err)
      }
    };

    fetchWebsites();
    fetchOwners();
    fetchDirectSignupStatus();
  }, []);

  const websiteOptions = websites.map((website) => ({
    label: website.name,
    value: website.name,
  }));

  // };

  const handleSearch = () => {
    const formattedStartDate = filters.start_date
      ? dayjs(filters.start_date).format("YYYY-MM-DD") // Formats as ISO string
      : null;
    const formattedEndDate = filters.end_date
      ? dayjs(filters.end_date).format("YYYY-MM-DD") // Formats as ISO string
      : null;
    onSearch({
      ...filters,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
    });
  };

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleCancel = async () => {
    setFilters({
      email: "",
      username: "",
      ownership: "",
      inactive_since_last_quarter: "",
      visibility: "",
      start_date: "",
      end_date: "",
      type:"",
      site:"",
      phone_no:""
    });
    await getAllClients(1, pagination.pageSize);
  };

  const renderFilter = (filter) => {
    switch (filter) {
      case "email":
        return (
          <Input
            placeholder="Filter by Email"
            style={{ width: isMobile ? "80vw" : 300 }}
            value={filters.email}
            onChange={(e) => handleFilterChange("email", e.target.value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "start_date":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Start Date"
            value={filters.start_date}
            onChange={(value) => handleFilterChange("start_date", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "end_date":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by End Date"
            value={filters.end_date}
            onChange={(value) => handleFilterChange("end_date", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "inactive_since_last_quarter":
        return (
          <Select
            placeholder="Filter by Status"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.inactive_since_last_quarter || undefined}
            onChange={(value) =>
              handleFilterChange("inactive_since_last_quarter", value)
            }
            onKeyDown={handleKeyDown}
            allowClear
          >
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        );
      case "ownership":
        return (
          <Select
            placeholder="Filter by Ownership"
            style={{ width: 300, textAlign: "left" }}
            value={filters.ownership || undefined}
            options={owners.map((owner) => ({
              label: owner.user,
              value: owner.username,
            }))}
            onChange={(value) => handleFilterChange("ownership", value)}
            onKeyDown={handleKeyDown}
          />
        );
        case "status":
          return (
            <Select
              placeholder="Filter by Status"
              style={{ width: 300, textAlign: "left" }}
              value={filters.status || undefined}
              onKeyDown={handleKeyDown}
              options={remarksStatus.map((owner) => ({
                label: owner.label,
                value: owner.key,
              }))}
              onChange={(value) => handleFilterChange("status", value)}
            />
          );
        case "site": // Add the site-specific dropdown
        return (
          <Select
            placeholder="Select Site"
            style={{ width: 300, textAlign: "left" }}
            value={filters.site || undefined}
            onChange={(value) => handleFilterChange("site", value)}
            onKeyDown={handleKeyDown}
          >
            <Option value="10">Locus Assignment</Option>
            <Option value="12">Oz Assignments</Option>
          </Select>
        );
      case "type":
        return (
          <Select
            placeholder="Filter by Type"
            style={{ width: 300, textAlign: "left" }}
            value={filters.type || undefined}
            options={typeChoices.map((owner) => ({
              label: owner.name,
              value: owner.id,
            }))}
            onChange={(value) => handleFilterChange("type", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "visibility":
        return (
          <Select
            placeholder="Filter by Visibility"
            style={{ width: 300, textAlign: "left" }}
            value={filters.visibility || undefined}
            options={visibilities.map((visibilitie) => ({
              label: visibilitie.user,
              value: visibilitie.username,
            }))}
            onChange={(value) => handleFilterChange("visibility", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "username":
        return (
          <Input
            placeholder="Filter by Username"
            style={{ width: 300 }}
            value={filters.username}
            onChange={(e) => handleFilterChange("username", e.target.value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "website":
        return (
          <Select
            placeholder="Website"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.website || undefined}
            options={websiteOptions}
            onChange={(value) => handleFilterChange("website", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "phone_no":
          return (
            <PhoneInput
              inputStyle={{
                width: "300px",
                borderRadius: "4px",
                height: "32.5px",
              }}
              containerStyle={{
                borderRadius: "4px",
                marginLeft: "10px",
              }}
              country={"in"}
              disableDropdown={true}
              placeholder={"Enter phone number"}
              value={filters.phone_no}
              onChange={(phone) => handleFilterChange("phone_no", phone)}
              onKeyDown={handleKeyDown}
            />
          );
      default:
        return (
          <Input
            placeholder={`Filter by ${filter}`}
            style={{ width: 300 }}
            value={filters[filter] || ""}
            onChange={(e) => handleFilterChange(filter, e.target.value)}
            onKeyDown={handleKeyDown}
          />
        );
    }
  };

  const isWebsiteFilterPresent = filtersList.includes("website");

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{ background: "#eceff1", padding: "20px", borderRadius: "8px" }}>
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}>
          {filtersList.map((filter) => (
            <div key={filter} style={{ marginRight: 16 }}>
              {renderFilter(filter)}
            </div>
          ))}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginRight: isMobile ? 0 : "12px",
              justifyContent: isWebsiteFilterPresent
                ? "flex-end"
                : "space-between",
              width: isWebsiteFilterPresent ? "100%" : "auto",
            }}>
            <Button
              type="primary"
              style={{ width: 140, background: "#040724" }}
              icon={<SearchOutlined />}
              onClick={handleSearch}>
              Search
            </Button>
            <Button
              style={{ width: 140 }}
              type="default"
              onClick={handleCancel}>
              Reset
            </Button>
          </div>
        </div>
      </div>
      <AddClientModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        websites={websites}
      />
    </div>
  );
};

export default SearchFilters;
